import { EventEmitter, Injectable, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from './local-storage.service';
import { Observable, timer } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { RxStompConfig } from '@stomp/rx-stomp';

// Services
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { DataService } from './data.service';
import { GeneralService } from './general.service';
import { GoogleAnalitycsService } from './google-analitycs.service';
import { RoutingService } from './routing.service';
import { LanguageService } from './language.service';
import { RxStompService } from './rx-stomp.service';

// Models
import { PlayerArray } from '../model/player-model';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { PlayerProfileService } from './player-profile.service';
import { GamesService } from './games.service';
import { AesService } from './aes.service';

// const WebSocketConstructor = WebSocket;
declare let Stomp: any;
declare let jQuery: any;

@Injectable()

export class UserService {
    public loggedUser!: PlayerArray;
    public playerEmitter: EventEmitter<PlayerArray> = new EventEmitter<PlayerArray>();
    public playerInterval: any;
    public casinoAccessEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    public regulationStatusEmitter: EventEmitter<any> = new EventEmitter();
    public ws: any;
    public stompClient: any;
    public tokenTimeInterval: any;
    public connectionErrorModal: any = null;
    public forceLogoutInterval: any = null;
    public updatePlayerInterval: any = null;
    public webSocketReconnectTimeInterval: any = null;
    public idleTimeoutSub: any = null;
    public rxStompConnect: any;
    public setHeartBeatStatusData: any = null;
    public getPlayerRealityStatusService: any = null;
    private rxConnectCount: any = 0;
    public setRealityModalDisplayData: boolean = false;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        private dialog: MatDialog,
        private idle: Idle,
        private _apiService: ApiService,
        private _dataService: DataService,
        private _configService: ConfigService,
        private _generalService: GeneralService,
        private _cookieService: CookieService,
        private _localStorageService: LocalStorageService,
        private _routingService: RoutingService,
        private _languageService: LanguageService,
        private _googleAnalitycsService: GoogleAnalitycsService,
        private rxStompService: RxStompService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private _playerProfileService: PlayerProfileService,
        private _gamesService: GamesService,
        private _aesService: AesService
    ) { }

    // Login check
    setPlayer(data: PlayerArray) {
        this.loggedUser = data;
        this._localStorageService.set('player', data);
    }

    // setPlayerPersionalDetails
    setPlayerPersionalDetails(data: any) {
        this._localStorageService.set('playerPersionalDetails', data);
    }

    // Get PlayerPersionalDetails data
    getPlayerPersionalDetails(): any {
        return this._localStorageService.get('playerPersionalDetails');
    }

    public notifyUpdatePlayerData(player?: any) {
        let plyaerObj;
        if (player === undefined) {
            plyaerObj = this._localStorageService.get('player');
        } else {
            plyaerObj = player;
        }
        this.playerEmitter.next(plyaerObj);
    }

    // Get player data
    getPlayer(): any {
        return this._localStorageService.get('player');
    }

    // Get player flag
    getPlayerFlag(): any {
        return this._localStorageService.get('playerFlag');
    }

    // setAgentPlayerFlag check
    setAgentPlayerFlag(data: any) {
        this._localStorageService.set('agentPlayerFlag', data);
    }

    // getAgentPlayer check
    getAgentPlayerFlag() {
        return this._localStorageService.get('agentPlayerFlag');
    }

    // setPPPAgentPlayerDetails check
    setPPPAgentPlayerDetails(data: any) {
        this._localStorageService.set('pppAgentPlayerDetails', data);
    }

    // getPPPAgentPlayerDetails check
    getPPPAgentPlayerDetails() {
        return this._localStorageService.get('pppAgentPlayerDetails');
    }

    getPlayerLanguage() {
        let playerDetail: any = this._localStorageService.get('player');
        if (playerDetail) {
            return playerDetail.playerLanguage;
        }
    }

    updatePlayer() {
        // this.connectWs();
        // this.connectAndReconnectWs(true);
        this.updatePlayerData();
    }

    // Check update player
    updatePlayerCheck(obj: any): Observable<any> | any {
        let apiUrl = 'updatePlayer';
        return this._apiService.request('get', apiUrl, obj, {}, false);
    }

    updatePlayerData() {
        let obj = {};
        let me = this;
        this.updatePlayerCheck(obj).subscribe((data: any) => {
            try {
                if (data.errorCode === 2002) {
                    this._localStorageService.clear();
                    this.deleteCookie('authToken');
                    this._routingService.altRouterLink('home');
                    this._configService.notifyUserLogout();
                }

                if (data.errorCode === 2007) {
                    this._localStorageService.clear();
                    this.deleteCookie('authToken');
                    this._routingService.altRouterLink('home');
                    this._configService.notifyUserLogout();
                }

                if (data.success === true) {
                    // Update User name and Balance
                    let userData = JSON.parse(data.FE_PLAYER_DATA.FE_PLAYER_BOOLEAN_DATA[0]);
                    let playerFlag = JSON.parse(data.FE_PLAYER_DATA.FE_PLAYER_REGULATORY_FLAGS);
                    this._localStorageService.set('playerFlag', playerFlag);

                    let playerObj = this._localStorageService.get('player');
                    playerObj['totalMoney'] = userData.totalMoney;
                    playerObj['bonusMoney'] = userData.bonusMoney;
                    playerObj['cashMoney'] = userData.cashMoney;
                    playerObj['depositAllowed'] = userData.depositAllowed;
                    playerObj['withdrawalAllowed'] = userData.withdrawalAllowed;
                    
                    this._localStorageService.set('player', playerObj);
                    let loggedUser = <PlayerArray>{
                        playerId: data.FE_PLAYER_DATA.playerId,
                        userName: userData.userName,
                        cashMoney: userData.cashMoney,
                        bonusMoney: userData.bonusMoney,
                        totalMoney: userData.totalMoney,
                        playerCurrency: playerObj['playerCurrency'],
                        playerEmailVerified: userData.playerEmailVerified
                    };

                    this.updateCasinoAccess(data.FE_PLAYER_DATA.casino_access);
                    this.notifyCasinoAccess(data.FE_PLAYER_DATA.casino_access);

                    if (data.FE_PLAYER_DATA.casino_access === false) {
                        if (this.router.url === this._routingService.altRouterLinkActive('casino')) {
                            this._routingService.altRouterLink('home');
                        }
                    }

                    this.notifyUpdatePlayerData(loggedUser);
                    if (userData.isBan === true) {
                        this._localStorageService.clear();
                        this.deleteCookie('authToken');
                        this._routingService.altRouterLink('home');
                        this._configService.notifyUserLogout();
                    }

                    if (userData.isLocked === true) {
                        this._localStorageService.clear();
                        this.deleteCookie('authToken');
                        this._routingService.altRouterLink('home');
                        this._configService.notifyUserLogout();
                    }

                    if (userData.isForceLogout === true) {
                        this.forceLogoutApiCalled();
                    }
                }
            } catch (e) {
                console.log(e, 'exception caught in updatePlayerData');
            }
        }, (error: any) => {
            if (me.playerInterval) {
                console.log('logout is called clearInterval 22.....');
                if (isPlatformBrowser(this.platformId)) {
                    clearInterval(me.playerInterval);
                }
            }
            this._localStorageService.clear();
            this.deleteCookie('authToken');
            this._routingService.altRouterLink('home');
            this._configService.notifyUserLogout();
        });
    }

    rxStompWSConfiguration() {
        console.log('rxStomp connection....')
        const myRxStompConfig: RxStompConfig = {
            // Which server?
            brokerURL: this._configService.getWsConnectionUrl(),

            // Headers
            // Typical keys: login, passcode, host
            // connectHeaders: {
            //     login: 'admin',
            //     passcode: 'admin',
            // },

            // How often to heartbeat?
            // Interval in milliseconds, set to 0 to disable
            heartbeatIncoming: 0, // Typical value 0 - disabled
            heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

            // Wait in milliseconds before attempting auto reconnect
            // Set to 0 to disable
            // Typical value 500 (500 milli seconds)
            reconnectDelay: 3000,

            // Will log diagnostics on console
            // It can be quite verbose, not recommended in production
            // Skip this key to stop logging to console
            debug: (msg: string): void => {
                console.log(msg);
            },
        };
        this.rxStompConnect = new RxStompService();
        this.rxStompConnect.configure(myRxStompConfig);
        this.rxStompConnect.activate();

        this.stompSuccessCallback();
    }

    stompSuccessCallback() {
        console.log('stompClient connected--');
        this.playerActivityMonitoring();

        let playerDetail = this.getPlayer();
        if (playerDetail.playerInactivityFlag) {
            this.playerInactivityMonitoring();
        }
        // this.stompClient.debug = null;
    }

    playerActivityMonitoring() {
        let plyaerObj = this._localStorageService.get('player');
        let playerId = plyaerObj['playerId'] + '';
        this.rxStompConnect.watch(playerId).subscribe((message: any) => {
            console.log('queue message--', message);
            try {
                if (message.body) {
                    let data = JSON.parse(message.body);
                    if (data.status) {
                        let status = data.status;
                        if (status.isForceLogout == true) {
                            this.forceLogoutApiCalled();
                        }

                        if (status.overrideLogin == true) {
                            this.overrideLoginMsg(status);
                        }

                        if (status.playerForgot == true || status.selfExclusion == true || status.ban == true || status.lock == true) {
                            this._localStorageService.clear();
                            this.deleteCookie('authToken');
                            this._routingService.altRouterLink('home');
                            this._configService.notifyUserLogout();
                        }

                        if (status.withdrawalAllowed == false) {
                            this._routingService.altRouterLink('user/payout');
                        }

                        if (status.AUTOMATIC_WITHDRAW_THRESHOLD) {
                            this.withdrawalThresholdReached(status.AUTOMATIC_WITHDRAW_THRESHOLD);
                        }

                        if (status.depositAllowed == false) {
                            this._routingService.altRouterLink('user/deposit');
                        }

                        if (status.casino_access == true) {
                            this.updateCasinoAccess(data.FE_PLAYER_DATA.casino_access);
                            this.notifyCasinoAccess(data.FE_PLAYER_DATA.casino_access);
                        } else if (status.casino_access == false) {
                            if (this.router.url === this._routingService.altRouterLinkActive('casino')) {
                                this._routingService.altRouterLink('home');
                            }
                        }

                        for (let key in status) {
                            let val = status[key];

                            // update playerflag param
                            let getPlayerFlag = this._localStorageService.get('playerFlag');
                            if (getPlayerFlag[key] || getPlayerFlag[key] == true || getPlayerFlag[key] == false) {
                                getPlayerFlag[key] = val;
                                this._localStorageService.set('playerFlag', getPlayerFlag);
                            }

                            // update player details param
                            let playerDetails = this._localStorageService.get('player');
                            if (playerDetails[key] || playerDetails[key] == true || playerDetails[key] == false) {
                                playerDetails[key] = val;
                                this._localStorageService.set('player', playerDetails);
                            }
                        }
                        this.notifyUpdatePlayerData();
                    } else if (data.RealityCheck) {
                        let param = data.RealityCheck;
                        if (param.isRealityReached) {
                            param['isRealityRemaining'] = true;
                        }
                        this.dialog.closeAll();
                        this._routingService.altRouterLink('home');
                        this._generalService.infomodel('', '', '', '', 'realityCheckModal', param);
                    } else if (data.PXLStatus) {
                        this.getPXLStatus(data.PXLStatus);
                    }
                }
            } catch (err) {

            }
        }, {});
    }

    playerInactivityMonitoring() {
        let plyaerObj: any = this.getPlayer();
        let playerId = plyaerObj['playerId'] + '';
        this.rxStompConnect.watch('HEARTBEAT_TOPIC::player-'+playerId).subscribe((message: any) => {
            let data = JSON.parse(message.body);
            console.log('message.body>>>', data);
            if (data.messageType == 'REALITYGAMECOUNTERSTARTED') {
                this.setHeartBeatStatus(data.messageType);
                this.regulationStatusEmitter.next(data);
            }
            if (data.messageType == 'REALITYREACHED') {
                this.getRealityCheckStatus();
                this.onSendMessage(data.messageType);
            }
            if (data.messageType == 'REGULATION_STATUS') {
                this.regulationStatusEmitter.next(data);
            }
            if (data.messageType == 'REALITYEXPIRED') {
                timer(5000).subscribe(() => {
                    console.log('logout call triggered after 5 seconds');
                    this.resetIdleTime();
                    this.dialog.closeAll();
                    this.logout('The player was logged out due to the idle time interval being reached, as the player did not perform any activity on the frontend.');
                });
            }
        });    
    }

    onSendMessage(msgType) {
        let playerDetail: any = this.getPlayer();
        if (!playerDetail['playerInactivityFlag']) {
            return;
        }
        let messageType = msgType;
        let playerId = playerDetail['playerId'] + '';
        let encryptKey = this._aesService.encrypt(playerId);

        if (msgType == 'REALITYREACHED') {
            messageType = "REALITYCONFIRMED";
        }
        
        let params = {
            "playerId": encryptKey,
            "messageType": messageType
        } as any;
        
        console.log("params>>>", params);

        if (!this.rxStompConnect && this.rxConnectCount <= 2) {
            this.rxConnectCount++;
            setTimeout( ()=> {
                this.onSendMessage(msgType);
            }, 2000);
            return;
        }
    
        try {
            this.rxConnectCount = 0;
            this.rxStompConnect.publish({ 
                destination: 'playerbackendlistener', 
                body: JSON.stringify(params)
            });
        } catch (error: any) {
            console.error('Error publishing message:', error);
        }
    }

    getRealityCheckStatus(realityCheckType: string = '', data: any = {}) {
        if (this.getPlayerRealityStatusService) {
            this.getPlayerRealityStatusService.unsubscribe();
        }

        // If data is available, use it directly
        if (Object.keys(data).length) {
            this.getPlayerRealityCheckStatus(data, realityCheckType);
        // Otherwise, call the API
        } else {
            this.getPlayerRealityStatusService = this._gamesService.getPlayerRealityStatusApi().subscribe((res) => {
                let resData = res || {};
                if (resData.success) {
                    let msgData = resData.message;
                    if (msgData.playerRealityReached && !this.getRealityModalDisplayStatus()) {
                        console.log('AT BE SIDE - Time reached!');
                        this.getPlayerRealityCheckStatus(msgData, realityCheckType);
                        return;
                    }

                    if (msgData.expectedRealityReachedTime) {
                        const futureTimestamp = msgData.expectedRealityReachedTime; // already ms
                        const now = Date.now();
                        let diffMs = futureTimestamp - now;
                        if (diffMs < 0) {
                            diffMs = 0;
                        }

                        setTimeout(() => {
                            if (!this.getRealityModalDisplayStatus()) {
                                console.log('AT FE SIDE - Time reached!');
                                if (!msgData.playerRealityReached) {
                                    this.onSendMessage('REALITYREACHED');
                                }
                                this.getPlayerRealityCheckStatus(msgData, realityCheckType);
                            }
                        }, diffMs);
                    }
                } else {
                    // this.showError(resData);
                }
            }, err => {
                console.log('err', err);
                // this.showError(err);
            });
        }
    };

    showError(err: any) {
        let assets: any = this._dataService.getAssets('headerPage') || {};
        this._generalService.infomodel(assets.errormsg.headerPage_error_msg_title, 'Player does not have any active reality session!', assets.errormsg.headerPage_common_ok_btn);
    }

    getPlayerRealityCheckStatus(data, realityCheckType) {
        console.log('data>>>', data);
        console.log('realityCheckType>>>', realityCheckType);
        let param = data || {};
        if (!param.playerRealityConfirmedExpiry) {
            param['byDefaultCounterStart'] = false;
            param['leftPauseTime'] = 300; // 5 min 
        } else {
            param['byDefaultCounterStart'] = true;
            const now = Date.now();
            param['leftPauseTime'] = Math.ceil((param['playerRealityConfirmedExpiry'] - now) / 1000);
        }

        
        this.dialog.closeAll();
        if (parseInt(param['leftPauseTime']) <= 0) {
            console.log('FLICKER ISSUE AVOIDE HERE');
            return
        }

        this.setRealityModalDisplayStatus(true);
        let realityModal = this._generalService.infomodel('', '', '', '', 'realityCheckModal', param);
        realityModal.afterClosed().subscribe(result => {
            if (result == 'continueGame') {
                if (realityCheckType == 'deposit') {
                    this._routingService.altRouterLink('user/deposit');
                } else if (realityCheckType == 'limits') {
                    this._routingService.altRouterLink('user/limits');
                } else {
                    let gameData = this._gamesService.getGamePlayData();
                    gameData['isDetailPage'] = true;
                    gameData['routeUrl'] = 'home';
                    this._gamesService.setGamePlayData(gameData);
                    this._routingService.altRouterLink('game-play', {}, gameData.gameUrlName);
                }
            } else {
                this._routingService.altRouterLink('home');
            }
        });
    
        this._routingService.altRouterLink('home');
    }

    setRealityModalDisplayStatus(data: boolean) {
        this.setRealityModalDisplayData = data;
    }

    getRealityModalDisplayStatus() {
        return this.setRealityModalDisplayData;
    }

    setHeartBeatStatus(data) {
        this.setHeartBeatStatusData = data;    
    }

    getHeartBeatStatus() {
        return this.setHeartBeatStatusData;    
    }

    disconnectWs() {
        if (this.rxStompConnect) {
            console.log('socket disconnected--');
            this.rxStompConnect.deactivate();
        }
    }

    forceLogoutApiCalled() {
        this.forceLogout().subscribe(() => {
            this.onSendMessage('LOGOUT');
            this._localStorageService.clear();
            this.deleteCookie('authToken');
            this._routingService.altRouterLink('home');
            this._configService.notifyUserLogout();
        }, () => {
            console.log('updatePlayerForceLogout failure...');
        });
    }

    overrideLoginMsg(arg) {
        let logMsg = "Session terminated beucase you'r login for another device, IP " + arg['ipAddress'];
        console.log(logMsg);
        this.logout(logMsg);
    }

    updateCasinoAccess(val: any) {
        let userDetails = <PlayerArray>this._localStorageService.get('player');
        userDetails['casino_access'] = val;
        this._localStorageService.set('player', userDetails);
    }

    notifyCasinoAccess(access: any) {
        this.casinoAccessEmitter.next(access);
    }

    // Player force logout
    forceLogout(): Observable<any> | any {
        let apiUrl = 'logout';
        return this._apiService.request('post', apiUrl, '', {}, true);
    }

    // Player logout
    userLogOut(param: any = {}): Observable<any> | any {
        let apiUrl = 'logout';
        return this._apiService.request('post', apiUrl, param, {}, true);
    }

    //confrim email
    confrimEmail(data: any): Observable<any> | any {
        let apiUrl = 'confirmEmail-v1';
        return this._apiService.request('post', apiUrl, data, {}, false);
    }

    refreshTokenApi(data: any): Observable<any> | any {
        let apiUrl = 'token/refreshToken';
        return this._apiService.request('get', apiUrl, {}, {}, true);
    }

    playerDepositDeatailsApi(): Observable<any> | any {
        let apiUrl = 'playerProfile/playerDepositDeatails';
        return this._apiService.request('get', apiUrl, {}, {}, false);
    }

    depositUpdateStatusAnaliticApi(params: any): Observable<any> | any {
        let apiUrl = 'playerProfile/playerDepositDeatails';
        return this._apiService.request('get', apiUrl, {}, params, false);
    }

    verifyPlayerActivityApi(): Observable<any> | any {
        let apiUrl = 'verifyPlayerActivity';
        return this._apiService.request('get', apiUrl, {}, {}, true);
    }

    withdrawalThresholdReached(amount: any) {
        this._generalService.openWithadrawalThresholdModal(amount);
    }

    // logout
    logout(reason: any = 'Player clicked on the logout button and signed-out out of the frontend.') {
        let param = {
            "reason": reason
        }
        this.userLogOut(param).subscribe(() => {
            this.onSendMessage('LOGOUT');
            this.clearLocalStorage();
            let interval = this.getInterval();
            if (interval) {
                if (isPlatformBrowser(this.platformId)) {
                    clearInterval(interval);
                }
            }
            this._localStorageService.set('iFrameLogin', 2);
            this._configService.notifyUserLogout();
            this._dataService.setLoginState(false);
            this._playerProfileService.setPlayerProfileData({});
            this._routingService.altRouterLink('home');
            if (isPlatformBrowser(this.platformId)) {
                jQuery('body').removeClass('overflow-cls');
            }
        }, (err: any) => {
            if ((err.error && err.errorCode == 2002) || err == 'Server error') {
                this.onSendMessage('LOGOUT');
                this.clearLocalStorage();
                let interval = this.getInterval();
                if (interval) {
                    if (isPlatformBrowser(this.platformId)) {
                        clearInterval(interval);
                    }
                }
                this._localStorageService.set('iFrameLogin', 2);
                this._configService.notifyUserLogout();
                this._dataService.setLoginState(false);
                this._routingService.altRouterLink('home');
                if (isPlatformBrowser(this.platformId)) {
                    jQuery('body').removeClass('overflow-cls');
                }
            }
        });
    }

    checkAccess() {
        if (this.checkLoginUser() === false) {
            this._routingService.altRouterLink('home');
        }
    }

    // Check login
    checkLoginUser() {
        let islogged = false;
        let userDetails = this._localStorageService.get('player');
        if (userDetails !== null && userDetails !== undefined) {
            islogged = true;
        } else {
            islogged = false;
        }
        return islogged;
    }

    getPlayerCurrency() {
        let playerCurreny = this._dataService.getCountryCurrencyCode();
        let playerData = this.getPlayer();
        if (playerData) {
            playerCurreny = playerData.playerCurrency;
        }

        let ret = { currencyCode: 'EUR', currencySign: '€' };
        if (playerCurreny == 'USD') {
            ret = { currencyCode: 'USD', currencySign: '$' };
        } else if (playerCurreny == 'GBP') {
            ret = { currencyCode: 'GBP', currencySign: '£' };
        }
        return ret;
    }

    setPlayerLanguage(val: any) {
        let getLang = this._localStorageService.get('language');
        this._localStorageService.set('language', val);
        if (getLang != val) {
            this._languageService.loadLanguageData();
        }
    }

    // Remove player data local storage
    clearLocalStorage() {
        this._localStorageService.remove('sportBookHash');
        this._localStorageService.remove('player');
        this._localStorageService.remove('playerPersionalDetails');
        this._localStorageService.remove('playerFlag');
        this._localStorageService.remove('agentPlayerFlag');
        this._localStorageService.remove('pppAgentPlayerDetails');
        this._localStorageService.remove('loginTime');
        this._localStorageService.remove('taxDedcutionModal');
        this.deleteCookie('authToken');
        this.setHeartBeatStatus(null);
    }

    getInterval() {
        return this.playerInterval;
    }

    public setIsSiteBlocked(val: any) {
        this._localStorageService.set('isSiteBlocked', val);
    }

    public getIsSiteBlocked() {
        return JSON.parse(this._localStorageService.get('isSiteBlocked'));
    }

    // Check Site Accessibility
    checkSiteAccessibility(): Observable<any> | any {
        let apiUrl = 'checkSiteAccessibility';
        return this._apiService.request('get', apiUrl, '', '', false, false);
    }

    public getCheckSiteAccessibility(assets: any) {
        this.checkSiteAccessibility().subscribe((res: any) => {
            let data = JSON.parse(res.message);
            this.setIsSiteBlocked(data.siteBlocked);
            if (data.siteBlocked) {
                this._generalService.infomodel(assets.errormsg.headerPage_error_common_modal_site_access_title, assets.errormsg.headerPage_error_common_modal_site_access_msg, assets.errormsg.headerPage_common_ok_btn);
            }
        }, (err: any) => {
            let data = JSON.parse(err.message);
            this.setIsSiteBlocked(data.siteBlocked);
            if (data.siteBlocked) {
                this._generalService.infomodel(assets.errormsg.headerPage_error_common_modal_site_access_title, assets.errormsg.headerPage_error_common_modal_site_access_msg, assets.errormsg.headerPage_common_ok_btn);
            }

        });
    }

    public getPXLStatus(res: any) {
        let obj = res || {};
        let registerPageAssets: any = this._dataService.getAssets('registerPage') || {};
        this.dialog.closeAll();
        if (obj.success) {
            let message = registerPageAssets.errormsg.registerPageAssets_pxl_success_msg;
            if (obj.errorCode == 16001 || obj.errorCode == '16001') {
                message = registerPageAssets.errormsg.registerPageAssets_verification_passport_successfull_upload_utility_bill_error_msg;
            }
            this._googleAnalitycsService.trackingUserAction('event', 'verification_success');
            this._googleAnalitycsService.trackingUserAction('event', 'confirm_id');
            let infodModal = this._generalService.infomodel(registerPageAssets.errormsg.registerPageAssets_success_modal_title, message, registerPageAssets.errormsg.registerPage_modal_ok_btn);
            infodModal.afterClosed().subscribe(result => {
                if (obj.errorCode == 16001 || obj.errorCode == '16001') {
                    this.dialog.closeAll();
                    this._routingService.altRouterLink('user/documents');
                }
            });
        } else {
            let errorMessage = registerPageAssets.errormsg.registerPageAssets_pxl_error_msg;
            if (obj.errorCode) {
                let keyName = 'registerPageAssets_pxl_error_msg_' + obj.errorCode;
                errorMessage = registerPageAssets.errormsg[keyName];
            }

            if (!errorMessage) {
                errorMessage = registerPageAssets.errormsg.registerPageAssets_pxl_error_msg;
            }
            this._generalService.infomodel(registerPageAssets.errormsg.registerPage_error_modal_title, errorMessage, registerPageAssets.errormsg.registerPage_modal_ok_btn);
            let eventParam = {
                errorCode: obj.errorCode,
                errorMessage: errorMessage
            }
            this._googleAnalitycsService.trackingUserAction('event', 'verification_error', eventParam);
        }
    }

    deleteCookie(val: any) {
        let protocol = window.location.protocol;
        if (protocol.includes('https')) {
            this._cookieService.delete(val, '/', '', true);
        } else {
            this._cookieService.delete(val, '/');
        }
    }

    public setAuthToken(token: any) {
        this.deleteCookie('authToken');
        let protocol = window.location.protocol;
        if (protocol.includes('https')) {
            this._cookieService.set('authToken', token, 1000, '/', '', true);
        } else {
            this._cookieService.set('authToken', token, 1000, '/');
        }
    }

    public setAutoCompleteAuthToken(token: any) {
        this.deleteCookie('autoCompleteAuthToken');
        let protocol = window.location.protocol;
        if (protocol.includes('https')) {
            this._cookieService.set('autoCompleteAuthToken', token, 1000, '/', '', true);
        } else {
            this._cookieService.set('autoCompleteAuthToken', token, 1000, '/');
        }
    }

    public setSourceParams(sourceValue: any) {
        let sourceRegex = /^[A-Za-z0-9_-]+$/;
        this.deleteCookie('tracking_source');
        if (sourceValue && sourceRegex.test(sourceValue)) {
            let protocol = window.location.protocol;
            if (protocol.includes('https')) {
                this._cookieService.set('tracking_source', sourceValue, 1000, '/', '', true);
            } else {
                this._cookieService.set('tracking_source', sourceValue, 1000, '/');
            }
        }
    }

    public getSourceParams() {
        return this._cookieService.get('tracking_source');
    }

    clearTokenTimeInterval() {
        if (this.tokenTimeInterval) {
            if (isPlatformBrowser(this.platformId)) {
                clearInterval(this.tokenTimeInterval);
            }
        }
    }

    refreshAuthTokenApi(): Observable<any> | Promise<any> | any {
        let resultPromise = new Promise((resolve, reject) => {
            if (this.checkLoginUser() === false) {
                this.clearTokenTimeInterval();
                resolve(true);
                return;
            }

            this.clearTokenTimeInterval();
            this.clearUpdatePlayerInterval();
            this.disconnectWs();
            this.refreshTokenApi({}).subscribe((res: any) => {
                let data = res.message || {};
                if (res.success) {
                    this.setAuthToken(data.refreshToken);
                    this.rxStompWSConfiguration();
                    if (isPlatformBrowser(this.platformId)) {
                        let currentDate = moment(new Date());
                        let exDate = moment(data.expiredDate * 1000);
                        let diff = exDate.diff(currentDate, 'seconds');
                        // if ((diff * 1000 - 60000) <= 10000) {
                        //     if (this.tokenTimeInterval) {
                        //         this.clearTokenTimeInterval();
                        //     }
                        //     resolve(true);
                        //     return false;
                        // }

                        this.tokenTimeInterval = setInterval((event: any) => {
                            this.refreshAuthTokenApi();
                            this.clearTokenTimeInterval();
                        }, ((diff * 1000) - 60000));
                         resolve(true);
                    }
                }
            }, (err: any) => {
                console.log('err======', err);
                this.clearLocalStorage();
                // this.rxStompWSConfiguration();
                resolve(true);
            });
        });
        return resultPromise;
    }

    loadUpdatePlayerInterval() {
        this.clearUpdatePlayerInterval();
        if (isPlatformBrowser(this.platformId)) {
            this.updatePlayerInterval = setInterval(() => {
                this.updatePlayerData();
            }, 5000);
        }
    }

    clearUpdatePlayerInterval() {
        if (this.updatePlayerInterval) {
            if (isPlatformBrowser(this.platformId)) {
                clearInterval(this.updatePlayerInterval);
            }
        }
    }

    clearSetTimeout(val: any) {
        if (val) {
            clearTimeout(val);
        }
    }

    // after 15 min idle user logout and show message
    setIdlState() {
        this.idle.setIdle(300);
        this.idle.setTimeout(1500);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idleTimeoutSub = this.idle.onTimeout.subscribe(() => {
            console.log('idle timeout called');
            this.verifyPlayerActivity();
        });

        this.idle.onIdleStart.subscribe(() => {
            console.log("You've gone idle!");
        });

        this.idle.onIdleEnd.subscribe(() => {
            console.log("You're active again!");
        });

        this.idle.watch();
    }

    resetIdleTime() {
        this.idle.watch();
    }

    clearIdleTime() {
        this.idle.ngOnDestroy();
        this.idle.stop();
        this.idle.onTimeout.observers.length = 0;
        this.idle.onIdleStart.observers.length = 0;
        this.idle.onIdleEnd.observers.length = 0;
    }

    verifyPlayerActivity() {
        this.verifyPlayerActivityApi().subscribe((res: any) => {
            let data = res.message;
            if (!data.playerActivityFlag && this.checkLoginUser()) {
                this.logout('The player was logged out due to the idle time interval being reached, as the player did not perform any activity on the frontend.');
                setTimeout(() => {
                    this.dialog.closeAll();
                    let headerPageAssets: any = this._dataService.getAssets('headerPage') || {};
                    this._generalService.infomodel(
                        headerPageAssets.errormsg.headerPage_error_session_expired_title,
                        headerPageAssets.errormsg.headerPage_error_session_expired_msg,
                        headerPageAssets.errormsg.headerPage_common_ok_btn
                    );
                }, 1000);
                this.idleTimeoutSub.unsubscribe();
            }
        }, (err: any) => {
            console.log(err);
        });
    }

    checkForceLogout24Hrs() {
        let lastLoginTime = this._localStorageService.get('loginTime');
        if (!lastLoginTime) {
            return;
        }

        let currentDate = moment(new Date());
        let exDate = moment(new Date(lastLoginTime));
        let diff = currentDate.diff(exDate, 'minutes');
        let remaingMinute = 1440 - diff;
        if (this.forceLogoutInterval) {
            if (isPlatformBrowser(this.platformId)) {
                clearInterval(this.forceLogoutInterval);
            }
        }
        this.forceLogoutInterval = setInterval((event: any) => {
            if (isPlatformBrowser(this.platformId)) {
                clearInterval(this.forceLogoutInterval);
            }
            const logged24hrsModal = this._generalService.infomodel('', '', '', '', '24hrsLogoutInfoModal');
            logged24hrsModal.afterClosed().subscribe((result: any) => {
                this.logout();
            });
        }, ((remaingMinute * 60) * 1000));
    }

    public currecnySymbol(currency: any): any {
        if (currency == 'EUR') {
            return '€';
        }
        if (currency == 'TND') {
            return 'DTN';
        }
        if (currency == 'BRL') {
            return 'R$';
        }
    }
}
